<app-message-service
  [id]="messageId"
  [severity]="severityMessage"
  [summaryMessage]="summaryMessage"
  [detailMessage]="detailMessage"></app-message-service>
<div class="p-7 bg-lightest">
  <div class="md:inline">
    <div class="back md:ml-10 md:inline">
      <button
        *ngIf="isButtonVisible('POLICYDETAILS_BACK_BUTTON')"
        pButton
        class="back-accueil font-app-medium"
        (click)="resetView()">
        <i class="pi pi-arrow-left mr-4"></i>
        <span class="inline">{{ "homePage.back" | translate }}</span>
      </button>
    </div>
    <div class="flex relative">
      <app-detail-title-mrh
        *ngIf="isBranchMRH"
        [titleKey]="'contractDetails.title'"
        [reference]="reference"></app-detail-title-mrh>

      <app-detail-title-pj
        *ngIf="isBranchPJ"
        [titleKey]="'contractDetails.titlePJ'"
        [reference]="reference"></app-detail-title-pj>

      <app-detail-title-sa
        *ngIf="isBranchSA"
        [titleKey]="'contractDetails.titleSA'"
        [reference]="reference"></app-detail-title-sa>

      <!-- Bouton de menu pour mobile -->
      <button
        title="menu mobile"
        class="block ml-auto lg:hidden p-2"
        (click)="toggleMenu()">
        <i
          *ngIf="!isMenuOpen"
          class="pi pi-ellipsis-h"></i>
        <i
          *ngIf="isMenuOpen"
          class="pi pi-ellipsis-v"></i>
      </button>
      <div
        *ngIf="isMenuOpen"
        class="absolute top-full mt-2 bg-white shadow-lg rounded-lg p-2 z-50 w-screen -ml-7">
        <app-service-offerings-mrh
          *ngIf="!isPolicyWaitingForSignature && isBranchMRH"
          [policyId]="policyId"
          [policyReference]="reference"
          [isPolicyActive]="isPolicyActive"
          [hasLegalJr]="policyDetails.legalProtection"
          [isGdaAllowed]="isGdaAllowed"
          [productCode]="policyDetails.formulasAndOptionsInformations.formulaCode" />

        <app-service-offerings-pj
          *ngIf="!isPolicyWaitingForSignature && isBranchPJ"
          [policyId]="policyId"
          [policyReference]="reference"
          [isPolicyActive]="isPolicyActive"
          [isGdaAllowed]="isGdaAllowed"
          [isConfortProduct]="isConfortProduct" />

        <app-service-offerings-sa
          *ngIf="!isPolicyWaitingForSignature && isBranchSA"
          [policyId]="policyId"
          [policyReference]="reference"
          [isPolicyActive]="isPolicyActive"
          [isGdaAllowed]="isGdaAllowed"
          [isConfortProduct]="isConfortProduct"
          [fSDocument]="fSDocument" />
      </div>
    </div>
  </div>
  <div class="lg:grid lg:grid-cols-3 lg:gap-4 w-full">
    <div class="border-light border rounded-md shadow-none bg-white p-2 lg:ml-9 col-span-2 lg:w-[80%]">
      <div class="bg-lightest pb-2 p-4">
        <div class="flex justify-between p-4">
          <app-address-mrh
            *ngIf="isBranchMRH"
            [bgLogo]="'bg-primary'"
            [colorLogo]="'text-white'"
            [data]="addressData"></app-address-mrh>

          <app-title-pj
            *ngIf="isBranchPJ"
            [bgLogo]="'bg-primary'"
            [colorLogo]="'text-white'"></app-title-pj>

          <app-title-sa
            *ngIf="isBranchSA"
            [bgLogo]="'bg-primary'"
            [colorLogo]="'white'"
            [animalName]="animalName"></app-title-sa>

          <app-status-card
            *ngIf="policyDetails"
            [status]="policyDetails.status"
            [statusConfig]="policyStatusConfigStatus"
            [date]="policyDetails.effectiveStartDate"
            class="justify-end" />
        </div>

        <!-- CONTENT OF POLICY -->

        <app-detail-info-card-mrh
          *ngIf="isBranchMRH"
          [validityDate]="policyDetails.paymentDate"
          [monthlyPremiumTTC]="policyDetails.nextPaymentAmount"
          [promotionCode]="policyDetails.promotionCode"
          [effectiveStartDate]="policyDetails.effectiveStartDate"
          [terminationDate]="policyDetails.terminationDate"
          [untilTextKey]="'contractDetails.nextPayment'"
          [amountTextKey]="'contractDetails.debitAmount'"
          [promoTextKey]="'contractDetails.promoCode'"
          [policyStatus]="policyDetails.status"></app-detail-info-card-mrh>

        <app-detail-info-card-pj
          *ngIf="isBranchPJ"
          [validityDate]="policyDetails.paymentDate"
          [monthlyPremiumTTC]="policyDetails.nextPaymentAmount"
          [promotionCode]="policyDetails.promotionCode"
          [effectiveStartDate]="policyDetails.effectiveStartDate"
          [terminationDate]="policyDetails.terminationDate"
          [untilTextKey]="'contractDetails.nextPayment'"
          [amountTextKey]="'contractDetails.debitAmount'"
          [promoTextKey]="'contractDetails.promoCode'"
          [policyStatus]="policyDetails.status"></app-detail-info-card-pj>

        <app-detail-info-card-sa
          *ngIf="isBranchSA"
          [validityDate]="policyDetails.paymentDate"
          [monthlyPremiumTTC]="policyDetails.nextPaymentAmount"
          [promotionCode]="policyDetails.promotionCode"
          [effectiveStartDate]="policyDetails.effectiveStartDate"
          [terminationDate]="policyDetails.terminationDate"
          [untilTextKey]="'contractDetails.nextPayment'"
          [amountTextKey]="'contractDetails.debitAmount'"
          [promoTextKey]="'contractDetails.promoCode'"
          [policyStatus]="policyDetails.status"></app-detail-info-card-sa>

        <div class="w-full mt-4 px-4 flex">
          <button
            pButton
            class="w-full rounded-lg p-3 text-white bg-primary text-center text-sm lg:text-base justify-center font-app-regular mb-3"
            (click)="onContractAction()"
            *ngIf="policyDetails && policyDetails.status === policyStates.Wait4Sign">
            {{ "contractCard.signContract" | translate }}
          </button>
        </div>
        <div class="font-app-bold w-[97%] mx-auto mb-3">
          <p-tabView
            [(activeIndex)]="activeIndex"
            (onChange)="activeIndexChange($event)">
            <p-tabPanel
              header="Mon contrat"
              class="font-app-regular">
              @if (isBranchMRH) {
                <app-options-list-mrh [details]="policyDetails"></app-options-list-mrh>

                @if (policyDetails.formulasAndOptionsInformations.formulaCode === packageType.Essentielle) {
                  <app-warranty-options-mrh [details]="policyDetails"></app-warranty-options-mrh>
                }
                <app-housing-options-mrh [details]="policyDetails"></app-housing-options-mrh>
                <app-scholar-insurance-mrh
                  *ngIf="policyDetails && policyDetails.schoolInsuredChildsVM.childrenList.length > 0"
                  [children]="child"></app-scholar-insurance-mrh>
                <app-lessor-informations-mrh
                  *ngIf="policyDetails && policyDetails.optionalServicePolicyVm.sendCertificationOption === true"
                  [lessor]="lessor"
                  [lessorDateSentTerminationLetter]="lessorDateTerminationLetter"></app-lessor-informations-mrh>
              } @else if (isBranchPJ) {
                <app-options-list-pj [details]="policyDetails"></app-options-list-pj>
              } @else if (isBranchSA) {
                <app-options-list-sa [details]="policyDetails"></app-options-list-sa>
                <p-divider type="solid"></p-divider>
                <app-declaration-sa
                  *ngIf="isBranchSA"
                  [data]="policyDetails.riskItemInformations"></app-declaration-sa>

                <app-medical-history-sa
                  *ngIf="isBranchSA"
                  [data]="policyDetails.riskItemInformations">
                </app-medical-history-sa>
              }
              <p-divider type="solid"></p-divider>
              <app-payment-informations
                *ngIf="policyDetails"
                [paymentInformations]="policyDetails.bankInformationPolicyVm"></app-payment-informations>
              <div class="flex flex-col gap-3">
                <!--Consulter l'échéancier de paiement-->
                <button
                  *ngIf="
                    policyDetails &&
                    policyDetails.status !== policyStates.Terminated &&
                    policyDetails.status !== policyStates.Na
                  "
                  pButton
                  (click)="goToPaymentSchedule()"
                  class="w-full border-primary border-2 rounded-lg p-3 text-primary bg-white text-center mt-4 text-sm lg:text-base flex justify-center font-app-bold">
                  {{ "contractCard.viewSchedule" | translate }}
                </button>
                <div class="flex flex-col lg:flex-row gap-3">
                  <button
                    pButton
                    *ngIf="policyDetails && isGdaAllowed && isValidPolicyState && !isPartner() && false"
                    class="w-full border-primary border-2 rounded-lg p-3 text-primary bg-white text-center text-sm lg:text-base flex justify-center font-app-bold"
                    (click)="showPopup()">
                    {{ "contractCard.modifyContract" | translate }}
                  </button>
                  <button
                    pButton
                    *ngIf="isPolicyActive"
                    class="w-full border-primary border-2 rounded-lg p-3 text-primary bg-white text-center text-sm lg:text-base flex justify-center font-app-bold"
                    (click)="goToContactUs()">
                    {{ "contractCard.cancelContract" | translate }}
                  </button>
                </div>
              </div>
            </p-tabPanel>
            <p-tabPanel header="Mes documents">
              <app-documents-card
                *ngIf="policyDetails && policyDetails.documents.length > 0 && policyDetails.status"
                [documents]="policyDetails.documents"
                [documentName]="documentTypes"
                [policyStatus]="policyDetails.status"></app-documents-card>
            </p-tabPanel>
          </p-tabView>
        </div>
      </div>
    </div>
    <div class="relative">
      <div class="fixed hidden lg:flex flex-col space-y-4 ml-4">
        <app-service-offerings-mrh
          *ngIf="!isPolicyWaitingForSignature && isBranchMRH"
          [policyId]="policyId"
          [policyReference]="reference"
          [isPolicyActive]="isPolicyActive"
          [hasLegalJr]="policyDetails.legalProtection"
          [hasOptionPj]="getOptionPJOnContract()"
          [isGdaAllowed]="isGdaAllowed"
          [productCode]="policyDetails.formulasAndOptionsInformations.formulaCode" />

        <app-service-offerings-pj
          *ngIf="!isPolicyWaitingForSignature && isBranchPJ"
          [policyId]="policyId"
          [policyReference]="reference"
          [isPolicyActive]="isPolicyActive"
          [isGdaAllowed]="isGdaAllowed"
          [isConfortProduct]="isConfortProduct" />

        <app-service-offerings-sa
          *ngIf="!isPolicyWaitingForSignature && isBranchSA"
          [policyId]="policyId"
          [policyReference]="reference"
          [isPolicyActive]="isPolicyActive"
          [isGdaAllowed]="isGdaAllowed"
          [isConfortProduct]="isConfortProduct"
          [fSDocument]="fSDocument" />
      </div>
    </div>
  </div>
</div>
<app-popup-dialog
  *ngIf="visibleDialog"
  [visibleDialog]="visibleDialog"
  [saveMessage]="saveMessage"
  [showRejectButton]="true"
  (dialogEmitter)="onContractEditionValidate($event)">
</app-popup-dialog>
<app-contract-edition
  *ngIf="visibleContractEditionDialog"
  [isMrhBranch]="isBranchMRH"
  [isSaBranch]="isBranchSA"
  [policyDetails]="policyDetails"
  [policyId]="policyId"
  [lessorData]="lessor"
  [visibleDialog]="visibleContractEditionDialog"
  [editPersonnalData]="editPersonnalData"
  (dialogEmitter)="onContractEditionClose()"
  (emitUpdateValidation)="onUpdateValidation($event)">
</app-contract-edition>
